import { render, staticRenderFns } from "./QRCode.vue?vue&type=template&id=87c85bfa&scoped=true&"
import script from "./QRCode.vue?vue&type=script&lang=ts&"
export * from "./QRCode.vue?vue&type=script&lang=ts&"
import style0 from "./QRCode.vue?vue&type=style&index=0&id=87c85bfa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c85bfa",
  null
  
)

export default component.exports